import { SCREENS } from "./screens";

export const weeks = [
    {
        id: 1,
        date: '16.09',
        whereText: 'лабораторию искусственного интеллекта.',
        factText: 'В ней множество полезных проектов: есть даже сервис «Симптом-чекер» — для всех тех, ' + 
        'кто внимательно следит за здоровьем. Если почувствовал себя плохо, в сервисе можно описать симптомы ' + 
        'и получить предварительный диагноз.',
        answer: ['ВСЁ', 'ВМЕСТЕ'],
        letters: ['С,', ' А,', ' Н,', 'Т,', ' Д'],
        postText: 'Ого, у тебя получилось разгадать первую загадку! Но ещё не время расслабляться: ' + 
        'каждую неделю тебя ждёт новый шифр.\nСохраняй тонус и забирай награду за первую неделю!',
    },
    {
        id: 2,
        date: '23.09',
        whereText: 'центр робототехники.',
        factText: 'Ты уже знаешь, что в Сбере очень тёплый и дружный коллектив, но у нас есть те ещё манипуляторы! ' + 
        'И нет, речь не об абьюзерах!\n\nВ центре робототехники Сбера есть системы управления роботами-манипуляторами, ' +
        'которые используются в широком числе практических задач. На основе изображений с камер и датчиков алгоритмы ИИ ' + 
        'позволяют системе управления роботом принимать решения о том, каким образом подхватывать и перемещать предметы ' +
        'и проводить операции с ними.',
        answer: ['ЛЮБОВЬ'],
        letters: ['Т,',' Я,',' Е,','К,',' Т'],
        postText: 'Второй шифр разгадан — твои детективные способности безупречны! Получай награду за свою смекалку:'
    },
    {
        id: 3,
        date: '30.09',
        whereText: 'лабораторию геймификации.',
        factText: 'Чтобы отдых в компании был насыщенным, лаборатория разрабатывает множество проектов. ' + 
        'В результате исследований и разработок лаборатории геймификации появляются анимированные аватары, ' +
        'обучающие «через игру» платформы, квесты и викторины. Скучно точно не будет!',
        answer: ['БАЛАНС'],
        letters: ['Щ,',' Т,',' Е,',' И'],
        postText: 'Шифры всё сложнее и сложнее, но тебя это не останавливает! Получай заслуженные призы.'
    },
    {
        id: 4,
        date: '07.10',
        whereText: 'лабораторию блокчейн.',
        factText: 'Проекты этой лаборатории делают так, чтобы тебе было легче работать. Они автоматизируют процессы, и твоя нагрузка снижается:)',
        answer: ['ГИМНАСТ'],
        letters: ['О,',' В,',' Ы,',' Й,', ' И'],
        postText: 'Над этим шифром и правда нужно было поломать голову. Ты точно заслуживаешь новые награды!'
    },
    {
        id: '4_1',
        isFinal: true,
        date: '07.10',
        postText: 'Последний шифр успешно разгадан! Получай заслуженные награды!',
        letters: [],
    }
];

export const WEEK_TO_GAME = {
    1: SCREENS.GAME1,
    2: SCREENS.GAME2,
    3: SCREENS.GAME3,
    4: SCREENS.GAME4,
}
